module.exports = __webpack_public_path__ + "static/media/thumbnail.a40a28d8.jpg";